import { Surface } from '@core/ui';

/**
 * Shown when `CLERK_PUBLISHABLE_KEY` is still the placeholder.
 *
 * `ClerkProvider` throws on an invalid key, which would blank the page with a console
 * error. Detecting it first turns a confusing crash into instructions -- and keeps the
 * design galleries reachable so frontend work can continue before Clerk exists.
 */
export function ClerkNotConfigured() {
  return (
    <div className="bg-bg text-fg grid min-h-dvh place-items-center p-6">
      <Surface radius="sheet" className="max-w-lg p-8">
        <h1 className="text-[22px] font-semibold tracking-[-0.017em]">Clerk is not configured</h1>
        <p className="text-fg-muted mt-2 text-[15px]">
          Set <code className="bg-fill-subtle rounded-xs px-1.5 py-0.5">CLERK_PUBLISHABLE_KEY</code>{' '}
          in <code className="bg-fill-subtle rounded-xs px-1.5 py-0.5">public/env.js</code> to your
          Clerk instance&rsquo;s publishable key.
        </p>
        <ol className="text-fg-muted mt-4 list-decimal space-y-1.5 pl-5 text-[14px]">
          <li>Create an application at dashboard.clerk.com.</li>
          <li>
            Add the email claim under <em>Customize session token</em>:{' '}
            <code className="bg-fill-subtle rounded-xs px-1 py-0.5 text-[12px]">
              {'{ "email": "{{user.primary_email_address}}", "name": "{{user.full_name}}" }'}
            </code>{' '}
            &mdash; the backend cannot provision a user without it.
          </li>
          <li>
            Set <code className="bg-fill-subtle rounded-xs px-1 py-0.5">CLERK_ISSUER_URI</code> on
            the backend to the same instance&rsquo;s Frontend API origin.
          </li>
        </ol>
        <a
          href="/dev"
          className="rounded-pill bg-accent text-accent-fg shadow-raised ease-spring mt-6 inline-block px-4 py-2 text-[14px] font-medium transition-transform duration-200 active:scale-[0.97]"
        >
          Continue to the design galleries
        </a>
      </Surface>
    </div>
  );
}
